import { closeCreateFormSheet } from '@/redux/slices/createFormSheetSlice'
import usePlatformColor from '@/lib/hooks/usePlatformColor'
import { useAppDispatch, useAppSelector } from '@/redux/store'
import { TrueSheet } from '@lodev09/react-native-true-sheet'
import { useCallback, useEffect, useRef } from 'react'
import { Platform } from 'react-native'
import CreateForm from './CreateForm'

export default function CreateFormSheet() {
  const dispatch = useAppDispatch()
  const sheetRef = useRef<TrueSheet>(null)
  const presentedRef = useRef(false)
  const { open, folderToken } = useAppSelector(state => state.createFormSheet)

  const [backgroundColor] = usePlatformColor('systemGroupedBackgroundColor')
  const currentUserLoaded = useAppSelector(state => state.currentUser.loaded)
  const currentUser = useAppSelector(state => state.currentUser.user)

  useEffect(() => {
    if (open && !presentedRef.current) {
      presentedRef.current = true
      const present = () => {
        sheetRef.current?.present().catch(() => { presentedRef.current = false })
      }
      // Android CoordinatorLayout needs a frame to be ready after previous dismiss
      if (Platform.OS === 'android') {
        requestAnimationFrame(present)
      } else {
        present()
      }
    }
  }, [open])

  const handleDismiss = useCallback(() => {
    presentedRef.current = false
    dispatch(closeCreateFormSheet())
  }, [dispatch])

  const handleClose = useCallback(() => {
    if (!presentedRef.current) return
    presentedRef.current = false
    dispatch(closeCreateFormSheet())
    sheetRef.current?.dismiss().catch(() => {})
  }, [dispatch])

  return (
    <TrueSheet ref={sheetRef} name="create-form-sheet" detents={['auto']} grabber backgroundColor={backgroundColor} onDidDismiss={handleDismiss}>
      {currentUserLoaded && currentUser && (
        <CreateForm currentUser={currentUser} folderToken={folderToken ?? undefined} onDismiss={handleClose} />
      )}
    </TrueSheet>
  )
}
